import { browser } from "$app/environment";
import { PUBLIC_RECAPTCHA_KEY } from "$env/static/public";
import { useScriptLoader } from "./load-script";


export async function setupClient() {
	if (!browser) return;

	// How this code snippet works:
  // This logic overwrites the default behavior of `grecaptcha.ready()` to
  // ensure that it can be safely called at any time. When `grecaptcha.ready()`
  // is called before reCAPTCHA is loaded, the callback function that is passed
  // by `grecaptcha.ready()` is enqueued for execution after reCAPTCHA is
  // loaded.
	const _win = window as { grecaptcha?: any, ___grecaptcha_cfg?: any };
	if(!('grecaptcha' in _win) || typeof _win.grecaptcha === 'undefined') {
    _win.grecaptcha = {};
  }
  _win.grecaptcha.ready = function(cb: () => void){
    if(typeof _win.grecaptcha === 'undefined') {
      // window.__grecaptcha_cfg is a global variable that stores reCAPTCHA's
      // configuration. By default, any functions listed in its 'fns' property
      // are automatically executed when reCAPTCHA loads.
      const c = '___grecaptcha_cfg';
      _win[c] = _win[c] || {};
      (_win[c]['fns'] = _win[c]['fns']||[]).push(cb);
    } else {
      cb();
    }
  }
}

export type RecaptchaToken = string;

export async function execute(action: string) {
	const _win = window as { grecaptcha?: any };
	if(!('grecaptcha' in _win) || typeof _win.grecaptcha === 'undefined') {
		throw new Error('reCAPTCHA has not been loaded yet.');
	}
	return _win.grecaptcha.execute(PUBLIC_RECAPTCHA_KEY, { action }) as Promise<RecaptchaToken>;
}
